module.exports = __webpack_public_path__ + "img/pellets-banner-960w.605b407.webp";